module.exports = __webpack_public_path__ + "img/partner_icon21.dd0291f9.png";